import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Api } from '@blink/components';

import router from './routes';

import './index.css';
import { ErrorBoundaryFallback } from '@/app/Errors';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
console.table({
    'Margin Account': Api.APP_DISPATCHER_ADDRESS,
});

root.render(
    <React.StrictMode>
        <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
            <RouterProvider router={router} />
        </ErrorBoundary>
    </React.StrictMode>,
);
